module.exports = __webpack_public_path__ + "static/media/add-supply-icon.e06598d4.svg";